import {ProductRepository} from '../repository/ProductRepository';
import {ProductType} from '../models/productType.model';

export class GetAllProductTypesUseCase {
  constructor (private repo: ProductRepository) {}
  async execute (): Promise<ProductType[]> {
    return this.repo.getProductTypes();
  }
}
